import script from "./GalleryHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./GalleryHeader.vue?vue&type=script&lang=ts&setup=true"

import "./GalleryHeader.vue?vue&type=style&index=0&id=a1651e14&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a1651e14"]])

export default __exports__